<app-dialog-wrapper>
  <div class="content">
    <app-input
      [formControl]="aptSuite"
      label="Apt/Suite"
      placeholder="Example: 2B"
    />
  </div>

  <div footer class="footer">
    <app-button
      [outline]="true"
      [size]="ButtonSize.Large"
      [style]="ButtonStyle.Danger"
      (buttonClick)="closeDialog()"
    >
      Cancel
    </app-button>

    <app-button [size]="ButtonSize.Large" (buttonClick)="onSave()">
      Save
    </app-button>
  </div>
</app-dialog-wrapper>
